/**
 * Arduino Auth0 Handler
 */

import auth0 from 'auth0-js';

(function() {
    var authParams;
    var webAuth;
    var authentication;

    // const accountMenuToggleSelector = '.ino-account-menu__toggle';
    // const accountMenuSelector = '.ino-account-menu';

    // function onSignIn(event) {
    //     event.preventDefault();
    
    //     const authorizeUrl = authentication.buildAuthorizeUrl(authParams);
    //     window.location = authorizeUrl;
    // }
    
    function onLogout(event) {
        event.preventDefault();
    
        const logoutUrl = authentication.buildLogoutUrl(authParams);
        window.location = logoutUrl;
    }
    
    // function toggleAccountMenu(event) {
    //     event.stopPropagation();
    
    //     const customerMenu = document.querySelector(accountMenuSelector);
    //     customerMenu.classList.toggle('visible');
    // }

    function buildRedirectUrl(hash) {
        const searchParams = new URLSearchParams(window.location.search);

        // check if return to param present in the URL
        let returnTo = '';
        if(searchParams.has('checkout_url')) {
            returnTo = searchParams.get('checkout_url');
        }

        if(returnTo) {
            authParams.returnTo = returnTo;
        }

        const redirectUrl = new URL(authentication.buildAuthorizeUrl(authParams));

        if(hash) {
            redirectUrl.hash = hash;
        }

        return redirectUrl.href;
    }

    function replaceAuthLinks() {
        // sign in
        const signInButtons = document.querySelectorAll('a[data-auth0-sign-in]');
        const signInLink = buildRedirectUrl('#/sso/login');

        for(let element of signInButtons) {
            element.href = signInLink;
        }

        // sign up
        const signUpButtons = document.querySelectorAll('a[data-auth0-sign-up]');
        const signUpLink = buildRedirectUrl('#/sso/register');

        for(let element of signUpButtons) {
            element.href = signUpLink;
        }
    }

    function init() {
        // initialize auth0
        // window.auth.parameters are defined in /layouts/theme.liquid
        authParams = window.auth.parameters;
        webAuth = new auth0.WebAuth(authParams);
        authentication = new auth0.Authentication(authParams);

        // replace links for sign in and sign up buttons
        replaceAuthLinks();

        // add logout button listener
        const logoutButton = document.querySelector('#logout');

        if(logoutButton) {
            logoutButton.addEventListener('click', onLogout);
        }

        // account menu toggle and click outside events
        // const accountMenuToggle = document.querySelector(accountMenuToggleSelector);
        
        // if(accountMenuToggle) {
        //     accountMenuToggle.addEventListener('click', toggleAccountMenu);

        //     // clickaway event
        //     window.addEventListener('click', (event) => {
        //         const customerMenu = document.querySelector(accountMenuSelector);
        //         if(customerMenu) {
        //             customerMenu.classList.remove('visible');
        //         }
        //     });
        // }

        // automatic redirect
        const redirectTrigger = document.querySelector('[data-auth0-redirect]');

        if(redirectTrigger) {
            const redirectUrl = buildRedirectUrl('#/sso/login');
            window.location = redirectUrl;
        }
    }

    window.addEventListener('load', init);
})();